import PillButton from "@/app/shared/PillButton";
import { Box, Popover } from "@mui/material";
import { useEffect, useState } from "react";
import { useBodyBackdrop } from "./useBodyBackdrop";
import AspectSelectedLabel from "./AspectSelectedLabel";
import AspectClearableLabel from "./AspectClearableLabel";

export default function AspectMenu({
  label,
  selectedLabel,
  isSelected,
  icon,
  isFilterBarExpanded,
  body,
  onClear,
  target,
  onOpen,
}: {
  label: string;
  selectedLabel?: string;
  isSelected?: boolean;
  icon: React.ReactNode;
  isFilterBarExpanded?: boolean;
  body: (handleClose: () => void) => React.ReactNode;
  onClear?: () => void;
  target?: React.ReactNode;
  onOpen?: () => void;
}) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const { backdropOpen, setBackdropOpen } = useBodyBackdrop();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setBackdropOpen(true);
    if (onOpen) {
      onOpen();
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
    if (!isFilterBarExpanded) {
      setBackdropOpen(false);
    }
  };

  useEffect(() => {
    if (!backdropOpen) {
      setAnchorEl(null);
    }
  }, [backdropOpen]);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <AspectSelectedLabel label={label} selectedLabel={selectedLabel}>
      {target ? (
        <Box onClick={handleClick}>{target}</Box>
      ) : (
        <PillButton
          startIcon={icon}
          isSelected={!!isSelected}
          onClick={handleClick}
        >
          <AspectClearableLabel
            label={selectedLabel || label}
            isSelected={!!isSelected}
            onClear={onClear}
          />
        </PillButton>
      )}

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        slotProps={{
          root: {
            sx: {
              maxHeight: "calc(100vh - 270px)",
            },
          },
        }}
      >
        {body(handleClose)}
      </Popover>
    </AspectSelectedLabel>
  );
}
